'use client'

// src/context/itinerary/useItinerary.ts
import { useContext } from "react";

// src/context/itinerary/context.tsx
import { createContext } from "react";
var ItineraryContext = createContext({
  id: "",
  itineraries: [],
  addItinerary: () => {
  },
  getItinerary: () => void 0,
  deleteItinerary: () => {
  },
  mode: "summary",
  setMode: () => {
  },
  activeDay: null,
  setActiveDay: () => {
  },
  handleSearch: () => {
  },
  search: "",
  toggleEventSelection: () => {
  },
  cancelSelection: () => {
  },
  confirmSelection: () => {
  },
  isEventInDay: () => false,
  selectedEvents: [],
  updateItinerary: () => {
  },
  reorderEvents: () => {
  }
});
var context_default = ItineraryContext;

// src/context/itinerary/useItinerary.ts
function useItinerary() {
  const context = useContext(context_default);
  if (!context) {
    throw new Error("useItinerary must be used within a ItineraryProvider");
  }
  return context;
}

export {
  context_default,
  useItinerary
};
//# sourceMappingURL=chunk-YBJOQHTL.mjs.map